import { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import CustomTable from '../../../../../../Common/Table/Table';
import { Constant } from '../../../../../../Helpers/constant';

const Table = props => {
  const [data, setData] = useState([]);
  const [bookingData, setBookingData] = useState([]);
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (props?.data?.length > 0) {
      setBookingData(
        props?.data?.map(games => {
          return { ...games };
        }),
      );
    } else {
      setData([]);
    }
  }, [props?.data]);

  useEffect(() => {
    if (bookingData?.length > 0) {
      const fetchColumns = [
        {
          name: 'S.No',
          width: '90px',
          wrap: true,
          selector: row => row?.serial_number,
        },
        {
          name: 'Game Name',
          width: '300px',
          cell: row => row?.game_name,
        },
        {
          name: 'Type',
          width: '180px',
          cell: row => row?.game_type,
        },
        {
          name: 'Status',
          width: '190px',
          cell: row => {
            const status = row?.game_status?.toLowerCase();
            let textColorClass = 'text-secondary'; // default

            if (status === 'draft') textColorClass = 'text-warning';
            else if (status === 'live') textColorClass = 'text-success';
            const formattedStatus = row?.game_status ? row.game_status.charAt(0).toUpperCase() + row.game_status.slice(1).toLowerCase() : '';

            return (
              <span className={textColorClass} style={{ padding: '6px 12px' }}>
                {formattedStatus}
              </span>
            );
          },
        },
        {
          name: 'Action',
          width: '190px',
          cell: row => (
            <div className="d-flex justify-content-center flex-column w-100 my-2">
              {row?.game_status === 'draft' && (
                <>
                  <span
                    className="btn btn-sm btn-primary mb-1"
                    onClick={() => {
                      actionBtnHandler(`UPDATE`, row?.orignam_data);
                    }}
                  >
                    Edit
                  </span>

                  <span
                    className="btn btn-sm btn-primary mb-1"
                    onClick={() => {
                      actionBtnHandler(`LIVE`, row?.orignam_data);
                    }}
                  >
                    Live
                  </span>
                </>
              )}
              {row?.game_status === 'live' && (
                <span
                  className="btn btn-sm btn-primary mb-1"
                  onClick={() => {
                    actionBtnHandler(`EXPIRE`, row?.orignam_data);
                  }}
                >
                  Expire
                </span>
              )}
            </div>
          ),
        },
      ];
      setColumns(fetchColumns);

      setData(
        bookingData?.map((data, index) => {
          return {
            serial_number: `${props?.limit * props?.pageNumber + (index + 1)}.`,
            game_name: data?.game_name,
            game_type: data?.game_type,
            game_status: data?.game_status,
            orignam_data: data,
          };
        }),
      );
    } else {
      setData([]);
      setColumns([]);
    }
  }, [bookingData]);

  /* ---------------------------- ACTION HANDLER ---------------------------- */
  const actionBtnHandler = (flag, data) => {
    if (flag === `LIVE`) {
      props.actionHandler({
        gameDetails: data,
        actionType: flag,
      });
    }
    if (flag === `EXPIRE`) {
      props.actionHandler({
        gameDetails: data,
        actionType: flag,
      });
    } else if (flag === `UPDATE`) {
      props.actionHandler({
        gameDetails: data,
        actionType: flag,
      });
    }
  };

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex">
              <h4 className="card-title mb-0 flex-grow-1">Gamification List</h4>
            </CardHeader>

            <CardBody>
              <CustomTable
                columns={columns ?? []}
                data={data ?? []}
                totalCount={props.totalCount}
                limit={props.limit}
                handleRowsPerPageChange={props.handleRowsPerPageChange} // Allows rows-per-page customization
                currentPage={props.pageNumber}
                handlePageChange={props.handlePageChange}
                indexType={Constant.INDEX_TYPE.ZERO_BASED}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Table;
